exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".table tr:first-child td[data-v-162bcdde], .table tr:first-child th[data-v-162bcdde] {\n  border-top: none;\n}\n.table td[data-v-162bcdde] {\n  padding-left: 0px !important;\n}\n", ""]);

// exports
